export default {
  activateLandingPageTitle: 'События',
  activateProductCardTitle: 'События',
  activateProductPageTitle: 'Забронировать события',
  allProductsLandingPageTitle: 'Бронируйте уникальные впечатления',
  apply: 'Применить',
  buyTickets: 'Купить билеты',
  cancel: 'Отмена',
  clear: 'Очистить',
  clearFilters: 'Очистить фильтры',
  discoverExperiences: 'Открыть впечатления',
  exclusive: 'Эксклюзив',
  experience: 'впечатление',
  experiencePhotoOfListing:
    'Фото впечатления {{photoNumber}} из объявления {{listingTitle}}',
  experiences: 'впечатления',
  filterExperiences: 'Фильтровать впечатления',
  hostedBy: 'Организатор:',
  hostLandingPageTitle: 'Местные впечатления',
  hostProductCardTitle: 'Местные впечатления',
  hostProductPageTitle: 'Забронировать местные впечатления',
  landingPageTitle: 'Бронируйте уникальные впечатления',
  mainLandingPageTitle: 'Все впечатления',
  more: 'Больше',
  noExperiencesFound: 'Впечатления не найдены',
  noExperiencesFoundFor: 'Впечатления не найдены по запросу',
  profileImageOfHost: 'Фото профиля организатора {{hostName}}',
  reserve: 'Забронировать',
  reserveLandingPageTitle: 'Мероприятия и удобства',
  reserveProductCardTitle: 'Мероприятия',
  reserveProductPageTitle: 'Забронировать мероприятия и удобства',
  resultsPageTitle: 'Бронировать впечатления и мероприятия',
};
